<template>
    <section id="features" class="features-section py-5 m-0 px-0">
      <div class="container">
        <!-- Header Section -->
        <div class="text-center mb-5 fade-in">
          <span class="text-dark text-uppercase fw-semibold mb-2 d-block d-none" style="letter-spacing: 1.5px; font-size: 0.9rem;">{{ t('features.sectionTitle') }}</span>
          <h2 class="display-5 fw-bold mb-4">{{ t('features.title') }}</h2>
          <p class="text-muted mb-4 mx-auto d-none" style="max-width: 600px;">{{ t('features.subtitle') }}</p>
        </div>
        
        <!-- Features Grid -->
        <div class="features-grid">
          <!-- Link in Bio -->
          <div class="feature-item fade-in">
            <div class="feature-card h-100">
              <div class="feature-icon-wrapper">
                <i class="fas fa-link"></i>
              </div>
              <h6 class="feature-title">{{ t('features.linkInBio.title') }}</h6>
              <p class="feature-desc">{{ t('features.linkInBio.description') }}</p>
            </div>
          </div>
          
     
          
          <!-- Digital Networking -->
          <div class="feature-item fade-in">
            <div class="feature-card h-100">
              <div class="feature-icon-wrapper">
                <i class="fas fa-users"></i>
              </div>
              <h6 class="feature-title">{{ t('features.networking.title') }}</h6>
              <p class="feature-desc">{{ t('features.networking.description') }}</p>
            </div>
          </div>


           <!-- Social Media -->
           <div class="feature-item fade-in">
            <div class="feature-card h-100">
              <div class="feature-icon-wrapper">
                <i class="fas fa-user"></i>
              </div>
              <h6 class="feature-title">{{ t('features.socialMedia.title') }}</h6>
              <p class="feature-desc">{{ t('features.socialMedia.description') }}</p>
            </div>
          </div>
          <!-- Content Hub -->



          <div class="feature-item fade-in">
            <div class="feature-card h-100">
              <div class="feature-icon-wrapper">
                <i class="fas fa-folder-open"></i>
              </div>
              <h6 class="feature-title">{{ t('features.content.title') }}</h6>
              <p class="feature-desc">{{ t('features.content.description') }}</p>
            </div>
          </div>
          <!-- Dashboard & Analytics -->


          <div class="feature-item fade-in">
            <div class="feature-card h-100">
              <div class="feature-icon-wrapper">
                <i class="fas fa-chart-line"></i>
              </div>
              <h6 class="feature-title">{{ t('features.dashboard.title') }}</h6>
              <p class="feature-desc">{{ t('features.dashboard.description') }}</p>
            </div>
          </div>
          
          <!-- vCard & QR Code -->
          <div class="feature-item fade-in">
            <div class="feature-card h-100">
              <div class="feature-icon-wrapper">
                <i class="fas fa-qrcode"></i>
              </div>
              <h6 class="feature-title">{{ t('features.qrVcard.title') }}</h6>
              <p class="feature-desc">{{ t('features.qrVcard.description') }}</p>
            </div>
          </div>
          
       
          
         
          
          <!-- Themes -->
          <div class="feature-item fade-in">
            <div class="feature-card h-100">
              <div class="feature-icon-wrapper">
                <i class="fas fa-palette"></i>
              </div>
              <h6 class="feature-title">{{ t('features.themes.title') }}</h6>
              <p class="feature-desc">{{ t('features.themes.description') }}</p>
            </div>
          </div>
          
          <!-- App Links -->
          <div class="feature-item fade-in">
            <div class="feature-card h-100">
              <div class="feature-icon-wrapper">
                <i class="fas fa-mobile-alt"></i>
              </div>
              <h6 class="feature-title">{{ t('features.appLinks.title') }}</h6>
              <p class="feature-desc">{{ t('features.appLinks.description') }}</p>
            </div>
          </div>
        </div>
        
        <!-- CTA Button -->
        <div class="text-center mt-5 fade-in">
          <a href="https://wa.me/25377604069" class="btn btn-primary btn-lg" target="_blank">
            <i class="fab fa-whatsapp"></i> {{ t('features.whatsapp') }}
          </a>
        </div>
      </div>
    </section>
  </template>
      
  <script>
  import { useTranslation } from '@/composables/useTranslation'
  
  export default {
    name: 'FeatureSection',
    setup() {
      const { t } = useTranslation()
      return { t }
    }
  }
  </script>
  
  <style lang="scss" scoped>
    /* Features Section */
    .features-section {
      background-color: #f8f9fa;
    }
    
    /* Features Grid - 4 colonnes */
    .features-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 1.5rem;
      margin-bottom: 3rem;
    }
    
    .feature-item {
      position: relative;
    }
    
    .feature-card {
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.08);
      border-radius: 12px;
      padding: 1.5rem;
      text-align: center;
      transition: all 0.3s ease;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
    }
  
    .feature-card:hover {
      transform: translateY(-8px);
      box-shadow: 0 12px 24px rgba(0,0,0,0.12);
      border-color: rgba(0,0,0,0.15);
    }
  
    .feature-icon-wrapper {
      width: 56px;
      height: 56px;
      border-radius: 14px;
      background: linear-gradient(135deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.1) 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 1rem;
      transition: all 0.3s ease;
    }
    
    .feature-card:hover .feature-icon-wrapper {
      background: linear-gradient(135deg, #000 0%, #333 100%);
      transform: scale(1.1);
    }
  
    .feature-icon-wrapper i {
      font-size: 24px;
      color: #333;
      transition: color 0.3s ease;
    }
    
    .feature-card:hover .feature-icon-wrapper i {
      color: #fff;
    }
    
    .feature-title {
      font-weight: 700;
      color: #222;
      margin-bottom: 0.5rem;
      font-size: 1rem;
    }
    
    .feature-desc {
      font-size: 0.875rem;
      color: #666;
      margin: 0;
      line-height: 1.4;
    }
    
    .btn-primary {
      background-color: #000;
      border-color: #000;
      padding: 0.875rem 2.5rem;
      font-weight: 600;
      transition: all 0.3s ease;
      border-radius: 50px;
    }
    
    .btn-primary:hover {
      background-color: #333;
      border-color: #333;
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0,0,0,0.2);
    }
    
    // Animations
    .fade-in {
      opacity: 0;
      transform: translateY(20px);
      animation: fadeInUp 0.6s ease forwards;
    }
    
    @for $i from 1 through 10 {
      .fade-in:nth-child(#{$i}) {
        animation-delay: #{$i * 0.08}s;
      }
    }
    
    @keyframes fadeInUp {
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    // Responsive
    @media (max-width: 1200px) {
      .features-grid {
        grid-template-columns: repeat(3, 1fr);
      }
    }
    
    @media (max-width: 768px) {
      .features-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
      }
      
      .feature-card {
        padding: 1.25rem;
      }
      
      .feature-icon-wrapper {
        width: 48px;
        height: 48px;
      }
      
      .feature-icon-wrapper i {
        font-size: 20px;
      }
    }
    
    @media (max-width: 480px) {
      .features-grid {
        grid-template-columns: repeat(2, 1fr);
      }
      
      .feature-title {
        font-size: 0.9rem;
      }
      
      .feature-desc {
        font-size: 0.8rem;
      }
    }
  
    @import '@/assets/styles/main.scss';
  </style>